// extracted by mini-css-extract-plugin
export default {"spinner_overlay":"Spinner_spinner_overlay__nZv4n","spinner":"Spinner_spinner__H2HDD"};